//
//
//
//
//
//
//
//
//
//
//
//
//

import ValidationMessages from './ValidationMessages.vue'

// noinspection JSUnusedGlobalSymbols
export default {
  name: 'WysiwygTextareaGroup',
  components: {
    ValidationMessages,
    'ckeditor-nuxt': () => {
      if (process.client) {
        return import('@blowstack/ckeditor-nuxt')
      }
    }
  },
  props: {
    label: {
      type: String,
      default: null
    },
    id: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: null
    },
    validation: {
      type: Object,
      default: null
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      ready: false,
      editorValue: '',
      count: 0,
      editorConfig: {
        removePlugins: [
          'Title',
          'MediaEmbed',
          'CloudServices',
          'AutoImage',
          'Image',
          'ImageCaption',
          'ImageInsert',
          'ImageResize',
          'ImageStyle',
          'ImageToolbar',
          'ImageUpload',
          'MediaEmbedToolbar',
          'LinkImage',
          'TodoList',
          'MathType',
          'Autolink'
        ],
        toolbar: {
          items: [
            'bold',
            'italic',
            'underline',
            '|',
            'alignment',
            '|',
            'link',
            'codeBlock',
            '|',
            'undo',
            'redo'
          ]
        },
        wordCount: {
          onUpdate: (stats) => {
            this.$emit('stats', stats)
            this.count = stats.characters
          }
        }
      }
    }
  },
  computed: {
    state () {
      if (this.validation) {
        return this.validation.$dirty ? !this.validation.$error : null
      }

      return null
    },
    description () {
      if (this.validation) {
        const descData = []

        if (this.validation?.$params?.richTextMinCharacters?.min) {
          descData.push('min ' + this.validation?.$params?.richTextMinCharacters?.min)
        }

        if (this.validation?.$params?.richTextMaxCharacters?.max) {
          descData.push('max ' + this.validation?.$params?.richTextMaxCharacters?.max)
        }

        descData.push('now ' + this.count)

        return `(${descData.join(' ')})`
      }

      return null
    }
  },
  mounted () {
    setTimeout(() => {
      this.editorValue = this.value || ''
    }, 100)
  },
  methods: {
    update (e) {
      this.$emit('input', e)
    }
  }
}
